import React from "react";
import stylesV2 from "./CalendarLinkModal.module.scss";
import stylesV3 from "./CalendarLinkModalV2.module.scss";
import { Modal } from "components/Modal";
import appleLinkIcon from "images/calendar-link-icon-apple.svg";
import googleLinkIcon from "images/calendar-link-icon-google.svg";
import outlookLinkIcon from "images/calendar-link-icon-outlook.svg";
import { CalendarLinks } from "types/calendarLinks";
import { useSchedulingABVariant } from "features/scheduling/utils/useSchedulingABVariant";

interface CalendarLinkModalProps {
  isModalOpen: boolean;
  links?: CalendarLinks;
  onRequestClose?: () => void;
}

export const CalendarLinkModal: React.FC<CalendarLinkModalProps> = ({
  isModalOpen,
  links,
  onRequestClose,
}) => {
  const{ isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  if (!links) {
    return null;
  }

  return (
    <Modal
      onRequestClose={onRequestClose}
      className={styles.modal}
      isOpen={isModalOpen}
    >
      <ul className={styles.list}>
        <li className={styles.listItem}>
          <a
            download="MyEyeDr Calendar Event"
            href={links.appleUrl}
            className={styles.link}
          >
            <img src={appleLinkIcon} className={styles.icon} alt="Apple" />
            Apple Calendar
          </a>
        </li>
        <li className={styles.listItem}>
          <a
            href={links.googleUrl}
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            <img src={googleLinkIcon} className={styles.icon} alt="Google" />
            Google Calendar
          </a>
        </li>
        <li className={styles.listItem}>
          <a
            href={links.outlookUrl}
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            <img src={outlookLinkIcon} className={styles.icon} alt="Outlook" />
            Outlook Calendar
          </a>
        </li>
      </ul>
    </Modal>
  );
};
